import { AppBar, Avatar, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Loader from "../util/Loader";
import LoadingAwal from "../util/LoadingAwal";
import PrintIcon from '@mui/icons-material/Print';

const ExportInvoice = () => {

    const [rows, setRows] = useState([]);
    const [isLoad, setIsLoad] = useState(true);
    const contentRef = useRef(null);
    const location = useLocation();
    const idInvoice = new URLSearchParams(location.search).get('id_');
    const idUser = new URLSearchParams(location.search).get('u_');

    

    useEffect(() => {
        const init = () => {
        axios.get(`https://ssr.radboox.com/data/invoice/client-export/${idUser}?id=${idInvoice}`)
        .then((res) => {
            const data = res.data.message;
            setRows(data)
            setIsLoad(false)
        }).catch((e) =>{
            setIsLoad(false)
        })
    }
        init();
    }, [idInvoice, idUser])

    const handlePrint = useReactToPrint({contentRef,
        onBeforePrint: () => {
            return new Promise((resolve) => {
                const style = document.createElement('style');
                style.innerHTML = `@page {size: landscape`;
                style.id = 'page-orientation';
                document.head.appendChild(style);
                resolve()
            });
        }
    });

    return (
        <>
        {isLoad ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>) : (
            <>
                {rows.data.length > 0 ? (
                    <>
                    
                        <Box className="noPrint" sx={{marginBottom: 4}}>
                            <AppBar position="fixed" sx={{bgcolor: "#1f283e"}}>
                                <Toolbar>
                                    <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/radboox-icon.png'} />
                                    <Typography
                                        variant="h6"
                                        noWrap
                                        component="a"
                                        href="https://www.radboox.com"
                                        sx={{
                                            mx: 2,
                                            fontSize: "26px",
                                            fontFamily: 'Roboto',
                                            fontWeight: 700,
                                            color: 'inherit',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        RadbooX
                                    </Typography>
                                    <Box sx={{ flexGrow: 1 }} />
                                    <Button startIcon={<PrintIcon />} sx={{width: "128px", marginX: 1}} color="inherit" variant="outlined" onClick={() => handlePrint()} className="noPrint">Print</Button>
                                </Toolbar>
                            </AppBar>
                            <Toolbar />
                        </Box>
                        <Box ref={contentRef}>
                            <Typography variant="h6">{rows.cp} - Invoice Table</Typography>
                            <Typography>Export Date: {rows.date}</Typography>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>No</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Address</TableCell>
                                            <TableCell>Phone</TableCell>
                                            <TableCell><Typography noWrap variant="body2">Number</Typography></TableCell>
                                            <TableCell><Typography noWrap variant="body2">Due Date</Typography></TableCell>
                                            <TableCell>Item</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.data.map((row) => (
                                            <TableRow key={row.uuid} sx={{ '&:last-child th': { border: 0 }, padding: 0 }}>
                                                <TableCell>{row.no}</TableCell>
                                                <TableCell>{row.fullName}</TableCell>
                                                <TableCell>{row.address}</TableCell>
                                                <TableCell>{row.wa}</TableCell>
                                                <TableCell>{row.noInvoice}</TableCell>
                                                <TableCell>{row.dueDate}</TableCell>
                                                <TableCell>{row.item}</TableCell>
                                                <TableCell>{row.status === 1 ? "Unpaid" : "Paid"}</TableCell>
                                                <TableCell>{row.total}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </>):(<>
                        <Box sx={{width: "100%", height: "70vh"}} display="flex" flexDirection="column" justifyContent='center' alignItems='center'>
                            <Typography variant="h2">404</Typography>
                            <Typography variant="h6">Invoice tidak dapat ditemukan</Typography>
                        </Box>
                    </>)
                }
            </>
        )}
        
        </>
    )
}

export default ExportInvoice;